import { Dispatch, SetStateAction } from 'react'
import Player from 'video.js/dist/types/player'

export enum VideoPlayerState {
  PLAYING = 'play',
  PAUSED = 'pause',
  ENDED = 'ended',
}

export interface SourceType {
  src: string
  type: string
}

export interface TrackType {
  src: string
  kind: string
  srclang: string
  label: string
}
export interface VideoQuality {
  id: string
  index: string
  label: string
  bandwidth: number
  bitrate: number
  height: number
  width: number
  enabled: any
}
export type VideoPlayerType = Player & {
  qualities: VideoQuality[]
  qualityIndex: number
  dash: any
  hlsjs: any
  setQuality: any
  qualityLevels: any
}

export interface PlayerOptions {
  autoplay: boolean
  controls: boolean
  loop?: boolean
  muted?: boolean
  preload?: string
  height?: number
  width?: number
  disablePictureInPicture?: boolean
  playbackRates?: number[]
  textTrackSettings?: boolean
  html5?: {
    nativeTextTracks?: boolean
  }
  controlBar?: {
    skipButtons: {
      backward: number
      forward: number
    }
    progressControl: {
      seekBar: {
        loadProgressBar: boolean
        mouseTimeDisplay: boolean
        playProgressBar: boolean
      }
    }
  }
  responsive?: boolean
  fluid?: boolean
  poster: string
  sources?: SourceType[]
  tracks?: TrackType[]
}
export interface VideoPlayerProps {
  options: PlayerOptions
  contextMenu?: boolean
  onEnd?: () => void
  onPlay?: (e: React.SyntheticEvent<HTMLVideoElement, Event>) => void
  onPause?: () => void
  onSeek?: () => void
  videoRef: React.RefObject<HTMLVideoElement | null>
  videoCategory?: string
  enableAnalytics?: boolean
  wrapperClassName?: string
  isCurriculumVideo?: boolean
  /** Seconds actually watched this playthrough (skipped time excluded) and the video's length. */
  onProgress?: (playedSeconds: number, videoLength: number) => void
  /** The video was taken back to the start — replayed after finishing, or seeked to 0. */
  onRestart?: () => void
}

export interface UseVideojsPlayerProps extends VideoPlayerProps {
  setVideoLength: Dispatch<SetStateAction<number>>
  setPlayTime: Dispatch<SetStateAction<number>>
}

export interface Cues {
  text: string
  startTime: number
  endTime: number
}
